import React from 'react'
import { StatisticsWidget5 } from '../../../../_metronic/partials/widgets/statistics/StatisticsWidget5'
import { TwoY_AxisChart } from '../../../../_metronic/partials/widgets/chartsComponents/TwoY_AxisChart'
import { ListsWidget6 } from '../../../../_metronic/partials/widgets/lists/ListsWidget6'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { MixedWidget1 } from '../../../../_metronic/partials/widgets/mixed/MixedWidget1';
import { useHotel2 } from '../../../contexts/HotelContext';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify'
import { DashboardWidget } from '../../../../_metronic/partials/widgets/statistics/DashboardWidget';


const CarouselComponent = (props) => {

    const { HotelId, setHotelId, HotelName, setHotelName } = useHotel2();

    const history = useHistory();

    const setHotel_id = (id) => {
        setHotelId(id);

    }

    const setHotel_Name = (name) => {
        setHotelName(name);
    }


    const onHotelNameTabClick = (hotelId, hotelname) => {

        setHotelId(hotelId);
        setHotelName(hotelname);


        history.push(`/hotels/hotelDashboard`)


    }

    const onEmployeeCountTabClick = (hotelId, hotelname) => {

        setHotelId(hotelId);
        setHotelName(hotelname);


        history.push(`/employees/AllEmployees`)


    }


    const onSundriesShopProductTabClick = (hotelId, hotelname, latestSundriesInventoryReportId) => {



        if (latestSundriesInventoryReportId != 0) {
            setHotelId(hotelId);
            setHotelName(hotelname);
    
          
            history.push(`/sundriesShopInventories/Details/${latestSundriesInventoryReportId}`)
      
          } else {
            toast.info('No report Found', { position: toast.POSITION.TOP_RIGHT });
          }
      

    }



    console.log('dashboardData in Carousel comp', props.dashboardData);
    return (
        <Carousel showThumbs={false} showStatus={false} useKeyboardArrows={true}>

            {props.dashboardData?.map((dashboardDataObj, index) => (

                <div className='card bg-white' key={index} style={{ marginRight: 28, marginLeft: 28 }}>
                    <div className='row g-2 g-sm-4 ' key={index + 1}>

                        {/* <div className=''> */}
                        <div className='col-sm-3 col-md-6 col-lg-3'
                            // onClick={() => onHotelNameTabClick(dashboardDataObj.hotelId, dashboardDataObj.hotelName)}
                        >
                            <DashboardWidget
                                className='card-xl-stretch  rounded'
                                svgIcon='/media/icons/duotune/hotelRooms/door.svg'
                                color='danger'
                                iconColor='white'
                                title={dashboardDataObj.hotelName}
                                description='Hotel Name'
                                onTabClick={() => onHotelNameTabClick(dashboardDataObj.hotelId, dashboardDataObj.hotelName)}
                            />

                        </div>

                        <div className='col-sm-3 col-md-6 col-lg-3'
                            // onClick={() => onEmployeeCountTabClick(dashboardDataObj.hotelId, dashboardDataObj.hotelName)}
                        >
                            <DashboardWidget
                                className='card-xl-stretch  rounded'
                                svgIcon='/media/icons/duotune/general/gen049.svg'
                                color='warning'
                                iconColor='white'
                                title={dashboardDataObj.numberOfEmployees}
                                description='Employees Count'
                                onTabClick={() => onEmployeeCountTabClick(dashboardDataObj.hotelId, dashboardDataObj.hotelName)}

                            />
                        </div>
                        {/* </div> */}

                        {/* <div className=''> */}

                        <div className='col-sm-3 col-md-6 col-lg-3'
                            // onClick={() => onSundriesShopProductTabClick(dashboardDataObj.hotelId, dashboardDataObj.hotelName,dashboardDataObj.latestSundriesInventoryReportId)}
                        >
                            <DashboardWidget
                                className='card-xl-stretch  rounded'
                                svgIcon='/media/icons/duotune/ecommerce/ecm002.svg'
                                color='info'
                                iconColor='white'
                                title={dashboardDataObj.totalSundriesShopProductsSales}
                                description='Sundries Shop Sales'
                                onTabClick={() => onSundriesShopProductTabClick(dashboardDataObj.hotelId, dashboardDataObj.hotelName,dashboardDataObj.latestSundriesInventoryReportId)}
                            />
                        </div>

                        <div className='col-sm-3 col-md-6 col-lg-3'>
                            <MixedWidget1
                                title='MPOR (Payroll Report)'
                                titleLabel='Total MPOR'
                                // titleValue={dashboardDataObj.payrollReportMPORList[0] !== undefined ? 
                                //     dashboardDataObj.payrollReportMPORList[0].item2 : ""
                                // }
                                showTitleTab={false}
                                label1={
                                    dashboardDataObj.payrollReportMPORList[0].item1
                                }
                                text1='department'
                                value1={
                                    dashboardDataObj.payrollReportMPORList[0].item2
                                }
                                condition1=''
                                show1={true}
                                label2={
                                    dashboardDataObj.payrollReportMPORList[1].item1}
                                text2='department'
                                value2={
                                    dashboardDataObj.payrollReportMPORList[1].item2}
                                condition2=''
                                show2={true}
                                label3={
                                    dashboardDataObj.payrollReportMPORList[2].item1}
                                text3={'department'}
                                value3={
                                    dashboardDataObj.payrollReportMPORList[2].item2}
                                condition3=''
                                show3={true}
                                // label4=''
                                // text4=''
                                // value4=''
                                show4={false}
                                marginTop='0px'
                                paddingMarginClasses='m-2 p-1'
                                icon1='/media/icons/duotune/art/art011.svg'
                                icon2='/media/icons/duotune/art/art011.svg'
                                icon3='/media/icons/duotune/art/art011.svg'
                                // condition4={false}
                                // className='card-xl-stretch mb-xl-8'
                                color='success'

                                hotelId={dashboardDataObj.hotelId}
                                hotelName={dashboardDataObj.hotelName}
                                setHotelID={setHotel_id}
                                setHotelName={setHotel_Name}
                                latestPayrollReportId={dashboardDataObj.latestPayrollReportId}


                            />
                        </div>
                        {/* </div> */}

                        {/* <div className='col-sm-3'>
                    <StatisticsWidget5
                        className='card-xl-stretch mb-xl-8 rounded'
                        svgIcon='/media/icons/duotune/general/gen027.svg'
                        color='primary'
                        iconColor='white'
                        title={dashboardDataObj.expiredSundriesShopProducts}
                        description='Expired Sundries Products'
                    />
                </div> */}

                    </div>

                    <div className='row mb-7'>

                        <div className='col-xl-9 col-md-12 col-sm-12 mb-10' key={Math.random()}>


                            <TwoY_AxisChart
                                ChartTitle={'MPOR and Payrolls By every two weeks Graph'}
                                // XAxislabels={datesList}
                                XAxislabels={dashboardDataObj.twoMonthsWeeksArray}

                                Dataset_1_Title={'MPOR (minutes)'}
                                Dataset_2_Title={'Payrolls ($s)'}
                                Dataset_1_Array={dashboardDataObj.lastSevenWeeksMPORList}
                                Dataset_2_Array={dashboardDataObj.lastSevenWeeksTotalPayrollsList}
                            />
                        </div>
                        <div className='col-xl-3 col-md-12 col-sm-12' key={Math.random()}>
                            <ListsWidget6 className='card-xl-stretch mb-xl-8'

                                value1={dashboardDataObj.totalRoomsCleaned}
                                value2={dashboardDataObj.totalRoomsSold}
                                value3={dashboardDataObj.totalLinenInventoriesToBOrdered}
                                label1={'Rooms Cleaned (Payroll Report)'}
                                label2='Rooms Sold (Latest Payroll Report)'
                                label3='Items To be Ordered (Latest Linen Inventory Report)'
                                hotelId={dashboardDataObj.hotelId}
                                hotelName={dashboardDataObj.hotelName}
                                setHotelID={setHotel_id}
                                setHotelName={setHotel_Name}
                                latestWeeklyWrapUpReportId={dashboardDataObj.latestWeeklyWrapUpReportId}
                                latestDocumentLibraryId={dashboardDataObj.latestDocumentLibraryId}
                                latestEOMLibraryId={dashboardDataObj.latestEOMLibraryId}
                                latestLinenInventoryReportId={dashboardDataObj.latestLinenInventoryReportId}
                                latestPayrollReportId={dashboardDataObj.latestPayrollReportId}

                            />
                        </div>


                    </div>

                </div>

            ))}

        </Carousel>

    )
}

export default CarouselComponent